import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeftIcon } from 'lucide-react';
export function OwnerFinderHero() {
  const [activeRow, setActiveRow] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveRow(prev => (prev + 1) % 3);
    }, 3000);
    return () => clearInterval(interval);
  }, []);
  const owners = [{
    business: 'Grand Central Bakery',
    owner: 'Sarah Johnson',
    title: 'Owner',
    email: 'sarah@grandcentralbakery.com'
  }, {
    business: 'Local Pet Supplies',
    owner: 'Mark Rivera',
    title: 'Founder',
    email: 'mark@localpetsupplies.com'
  }, {
    business: 'Bright Smile Dental',
    owner: 'Dr. Amy Chen',
    title: 'Owner',
    email: 'amy@brightsmile.com'
  }];
  return <section className="relative pt-16 pb-24 overflow-hidden bg-white" data-id="element-3833">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-3834">
        <a href="#/features" className="inline-flex items-center gap-2 text-sm font-semibold text-slate-500 hover:text-slate-900 transition-colors mb-8" data-id="element-3835">
          <ArrowLeftIcon className="w-4 h-4" data-id="element-3836" /> All Features
        </a>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-3837">
          {/* Left Column: Copy & CTAs */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="max-w-2xl" data-id="element-3838">
            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold tracking-tight text-slate-900 mb-8 leading-[1.05]" data-id="element-3839">
              Find local business <br data-id="element-3840" />
              <span className="text-blue-600" data-id="element-3841">owners</span> in minutes
            </h1>

            <p className="text-xl sm:text-2xl text-slate-600 mb-8 max-w-lg leading-relaxed" data-id="element-3842">
              Search 200M+ local businesses and instantly find business owner
              contacts —{' '}
              <span className="inline-flex items-center px-4 py-1 rounded-full bg-blue-50 text-blue-700 text-lg sm:text-xl font-medium mx-1" data-id="element-3843">
                verified emails
              </span>
              ,{' '}
              <span className="inline-flex items-center px-4 py-1 rounded-full bg-green-50 text-green-700 text-lg sm:text-xl font-medium mx-1" data-id="element-3844">
                verified owner contacts
              </span>
              , and{' '}
              <span className="inline-flex items-center px-4 py-1 rounded-full bg-purple-50 text-purple-700 text-lg sm:text-xl font-medium mx-1 mt-2 sm:mt-0" data-id="element-3845">
                verified direct phones
              </span>{' '}
              for every decision-maker.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-10" data-id="element-3846">
              <a href="http://app.openmart.com/register" target="_blank" rel="noopener noreferrer" className="px-10 py-4 text-white font-bold bg-blue-600 rounded-full hover:bg-blue-700 transition-colors text-lg text-center" data-id="element-3847">
                Try for free
              </a>
            </div>

            {/* Static Stats Bar */}
            <div className="flex gap-12 pt-8" data-id="element-3848">
              <div data-id="element-3849">
                <div className="text-3xl font-bold text-slate-900 mb-1" data-id="element-3850">
                  200M+
                </div>
                <div className="text-sm text-slate-500 font-medium" data-id="element-3851">
                  Local businesses
                </div>
              </div>
              <div data-id="element-3852">
                <div className="text-3xl font-bold text-slate-900 mb-1" data-id="element-3853">
                  50+
                </div>
                <div className="text-sm text-slate-500 font-medium" data-id="element-3854">
                  Data points per business
                </div>
              </div>
              <div data-id="element-3855">
                <div className="text-3xl font-bold text-slate-900 mb-1" data-id="element-3856">
                  Built-in
                </div>
                <div className="text-sm text-slate-500 font-medium" data-id="element-3857">
                  Sequencing
                </div>
              </div>
            </div>
          </motion.div>

          {/* Right Column: Live Data Preview Card */}
          <div className="relative" data-id="element-3858">
            <div className="bg-slate-50 rounded-[2rem] p-8 sm:p-10 relative z-10" data-id="element-3859">
              <div className="flex justify-between items-center mb-8" data-id="element-3860">
                <h3 className="text-2xl font-bold text-slate-900" data-id="element-3861">
                  Owner finder preview
                </h3>
              </div>

              <div className="overflow-x-auto" data-id="element-3862">
                <table className="w-full text-sm text-left" data-id="element-3863">
                  <thead data-id="element-3864">
                    <tr className="text-slate-400 font-medium border-b border-slate-200/60" data-id="element-3865">
                      <th className="pb-4 pl-4 pr-4 font-medium" data-id="element-3866">Business</th>
                      <th className="pb-4 px-4 font-medium" data-id="element-3867">Owner</th>
                      <th className="pb-4 px-4 font-medium" data-id="element-3868">Title</th>
                      <th className="pb-4 pl-4 font-medium" data-id="element-3869">Email</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-200/60" data-id="element-3870">
                    {owners.map((row, idx) => <tr key={idx} className={`transition-all duration-500 relative ${activeRow === idx ? 'bg-white shadow-sm rounded-xl' : ''}`} data-id="element-3871">
                        <td className="py-6 pl-4 pr-4 font-medium text-slate-900 rounded-l-xl whitespace-nowrap" data-id="element-3872">
                          {row.business}
                        </td>
                        <td className="py-6 px-4 text-slate-700 whitespace-nowrap" data-id="element-3873">
                          {row.owner}
                        </td>
                        <td className="py-6 px-4 text-slate-500 whitespace-nowrap" data-id="element-3874">
                          {row.title}
                        </td>
                        <td className="py-6 pl-4 rounded-r-xl" data-id="element-3875">
                          <div className="text-blue-600 font-medium truncate max-w-[150px] sm:max-w-none" data-id="element-3876">
                            {row.email}
                          </div>
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div>

              <div className="mt-8 pt-6 border-t border-slate-200/60 flex justify-end" data-id="element-3877">
                <a href="http://app.openmart.com/register" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 px-4 py-2 bg-slate-900 text-white text-sm font-semibold rounded-lg hover:bg-slate-800 transition-colors" data-id="element-3878">
                  Find business owners
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}